import { render } from "./SmsTitlesWidget.vue?vue&type=template&id=20419a93"
import script from "./SmsTitlesWidget.vue?vue&type=script&lang=js"
export * from "./SmsTitlesWidget.vue?vue&type=script&lang=js"

import "./SmsTitlesWidget.vue?vue&type=style&index=0&id=20419a93&lang=css"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__